declare namespace $ {

	type $mol_view__sub_bog_ui_app_empty_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_empty_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_empty_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_empty__Icon_bog_ui_app_empty_4 = $mol_type_enforce<
		ReturnType< $bog_ui_app_empty['Custom_icon_icon'] >
		,
		ReturnType< $bog_ui_empty['Icon'] >
	>
	type $bog_ui_empty__title_bog_ui_app_empty_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_empty['title'] >
	>
	type $bog_ui_empty__message_bog_ui_app_empty_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_empty['message'] >
	>
	type $mol_view__sub_bog_ui_app_empty_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__sub_bog_ui_app_empty_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $bog_ui_empty__Icon_bog_ui_app_empty_9 = $mol_type_enforce<
		ReturnType< $bog_ui_app_empty['Action_icon'] >
		,
		ReturnType< $bog_ui_empty['Icon'] >
	>
	type $bog_ui_empty__title_bog_ui_app_empty_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_empty['title'] >
	>
	type $bog_ui_empty__message_bog_ui_app_empty_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_empty['message'] >
	>
	type $bog_ui_empty__Action_bog_ui_app_empty_12 = $mol_type_enforce<
		ReturnType< $bog_ui_app_empty['Action_button'] >
		,
		ReturnType< $bog_ui_empty['Action'] >
	>
	export class $bog_ui_app_empty extends $mol_page {
		description( ): string
		Description( ): $mol_view
		section_default_title( ): string
		Section_default( ): $mol_view
		Default( ): $bog_ui_empty
		section_custom_title( ): string
		Section_custom( ): $mol_view
		Custom_icon_icon( ): $mol_icon_folder
		Custom_icon( ): $bog_ui_empty
		section_action_title( ): string
		Section_action( ): $mol_view
		Action_icon( ): $mol_icon_plus_circle
		action_label( ): string
		Action_button( ): $mol_button_major
		With_action( ): $bog_ui_empty
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=empty.view.tree.d.ts.map